import React from 'react';
import SideNav, { Nav, NavIcon, NavText } from 'react-sidenav';
import {Link} from 'react-router-dom';
import {Button} from 'reactstrap';

//Style
import '../../css/common.css';

/**
 * @param obj - one navigation item
 * @param type - topic type ("class", "test" or "exam")
 * @return {string} topic title (based on topic type)
 */
/*function getTitle(obj, type){
    if(type === "class")
    {
        return "Čas " + obj.week + ": " + obj.name;
    }
    else if(type === "test")
    {
        return obj.year + ": " + obj.descr;
    }
    else
    {
        return obj.year + ": " + obj.name;
    }
}*/

/**
 * @param list - topic collection
 * @param type - topic type ("class", "test" or "exam")
 * @param courseId
 * @return Navigation list where each topic is one item
 */
function generateNavigationItemList(list, type, courseId) {
    var result = list.map((item) => {

        var href="/p/courses/"+ courseId+ "/topic/" + item.id;
        return  (
            <Nav id={item.id}>
                <NavText>
                    <Link className="default-link" to={href}>
                        {item.name}
                    </Link>
                </NavText>
            </Nav>
        );
    });

    return result;
}

function PSideNavbar({classes, tests, exams, courseInfo}) {
    var classesHtml = generateNavigationItemList(classes, "class", courseInfo.idCourse);
    var testsHtml = generateNavigationItemList(tests, "test", courseInfo.idCourse);
    var examsHtml = generateNavigationItemList(exams, "exam", courseInfo.idCourse);

    return (
		<div id="sidenavcontainer" style = {{height: '100%'}}>
            <SideNav highlightColor='white' highlightBgColor='' defaultSelected='sales'>
                <div style={{padding: '20px', textAlign: 'center'}}>
					<Link className="default-link"
						to={"/p/courses/"+ courseInfo.idCourse}>{courseInfo.name} </Link>
                </div>
                <div style={{textAlign: 'center'}}>
                    <Link className="default-link"
                          to={"/p/courses/"+ courseInfo.idCourse+ '/edit'}> <Button color="primary"> Izmena kursa. Dodavanje tema. </Button></Link>
                </div>
                <Nav id='vezbe'>
                    <NavIcon> <span className="fa fa-keyboard-o"> </span> </NavIcon>
                    <NavText> Časovi vežbi </NavText>
                    {classesHtml}
                </Nav>

                <Nav id='tests'>
                    <NavIcon> <span className="fa fa-code"> </span> </NavIcon>
                    <NavText> Kolokvijumi </NavText>
                    {testsHtml}
                </Nav>

                <Nav id='exams'>
                    <NavIcon> <span className="fa fa-question-circle"> </span> </NavIcon>
                    <NavText> Ispiti </NavText>
                    {examsHtml}
                </Nav>

				<Nav id='submissions'>
					<NavIcon><span className='fa fa-list'></span></NavIcon>
					<NavText>
						<Link to={'/p/courses/'+courseInfo.idCourse + '/submissions/all'}
							className="default-link">
							Svi pokušaji za kurs
						</Link>
					</NavText>
				</Nav>

				<Nav id='submissionsRequested'>
					<NavIcon><span className='fa fa-comment-o'></span></NavIcon>
					<NavText>
						<Link to={'/p/courses/'+courseInfo.idCourse + '/submissions/requested'}
							className="default-link">
							Svi pokušaji za kurs sa pitanjima
						</Link>
					</NavText>
				</Nav>

            </SideNav>
        </div>
    );
}

export default PSideNavbar;
